module.exports = "<div class=\"main-footer clearfix\">\n  <div class=\"footer-pane text-center\">Copyright © {{year}}</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/housekeeping/views/footer.component.html
// module id = ./src/app/modules/housekeeping/views/footer.component.html
// module chunks = main